export enum MappingStatus {
  AI_GENERATED = 'ai_generated',
  USER_APPROVED = 'user_approved',
  USER_MODIFIED = 'user_modified',
  USER_CREATED = 'user_created',
}

export enum FieldMappingTaskStatus {
  DISABLED = 'disabled',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  INVALID = 'invalid',
}

export type FieldMappingData = {
  source_name: string;
  target_name: string;
  status: MappingStatus;
};

export type FieldMappingResponse = {
  id: number;
  organization_id: number;
  target_name: string;
  source_name: string;
  original_source_name: string;
  status: MappingStatus;
  is_deleted: boolean;
};

export type FieldOption = {
  normalized_attribute: string;
  attribute_text: string;
  attribute_type: string;
  value?: string | null;
};

export type ContactFieldGroup = {
  role: string;
  contact_source: string;
  fields: FieldOption[];
};

export type FieldMappingOptions = {
  matter_fields: FieldOption[];
  contact_fields: Record<string, ContactFieldGroup>;
};

export type FieldMappingSnapshotData = {
  target_field_name: string;
  source_field_name: string | null;
  source_picklist_options?: Record<string, string>;
};

export type FieldMappingSnapshotResponse = {
  target_field_name: string;
  source_field_name: string;
  source_picklist_options?: Record<string, string>;
};
